export const FOOTER_URLS = {
    findStore: 'https://ayuda.casaideas.cl/centro-ayuda/home/tiendas',
    aboutUs: '/contenido/sobre-nosotros',
    workWithUs: 'https://casaideas.trabajando.cl/',
    trackOrder:
        'https://ayuda.casaideas.cl/centro-ayuda/home/seguimiento-pedido',
    orderHelpExchangeReturn:
        'https://ayuda.casaideas.cl/centro-ayuda/seguimiento-pedido/cambio-devolucion',
    helpCenter: 'https://ayuda.casaideas.cl/centro-ayuda/home',
    instagram: 'https://www.instagram.com/casaideaschile/?hl=es',
    facebook: 'https://es-la.facebook.com/CasaideasChile/',
    pinterest: '#',
    linkedin: 'https://www.linkedin.com/company/casaideas/',
    tiktok: '#',
    youtube: '#',
    chile: 'https://www.casaideas.cl/',
    peru: 'https://www.casaideas.com.pe/',
    colombia: 'https://www.casaideas.com.co/',
    mexico: 'https://www.casaideas-mexico.mx/',
    bolivia: 'https://www.casaideas.com.bo/',
    sustainability: '/contenido/sostenibilidad',
    exchangeAndReturns:
        'https://ayuda.casaideas.cl/centro-ayuda/home/cambio-devolucion',
    officePolicies:
        'https://ayuda.casaideas.cl/centro-ayuda/home/tipos-entrega',
    clientProgram:
        'https://ayuda.casaideas.cl/centro-ayuda/home/programa-cliente',
    termsAndConditions:
        'https://ayuda.casaideas.cl/centro-ayuda/home/terminos-condiciones',
    privacyPolicy: '/content/privacy-policy',
    contact: 'https://ayuda.casaideas.cl/centro-ayuda/home/contacto',
    companyBuy: 'https://ayuda.casaideas.cl/centro-ayuda/home/venta-empresa',
    whatsNew: '/categoria/nuevo',
    cyberIdeas: '/contenido/cyber',
    blackIdeas: '#',
    outlet: '#',
    iosAppGuide: '#',
    androidApp: '#'
} as const
